<template>
    <v-container fluid>
        <v-row>
            <v-col cols="auto" class="d-flex" sm="3">
                <v-select v-model="semestre" hide-details dense :items="semestres" label="Semestre" item-value="Id"
                    item-text="Nombre" return-object style="width: 300px;" @change="selectSemestre" />
            </v-col>

            <v-spacer />

            <v-col cols="auto">
                <v-text-field v-model="filtro" hide-details dense clearable label="Filtro en listado"
                    style="width: 300px;" />
            </v-col>

        </v-row>
        <div class="grid-wrapper" tabindex="0" ref="grid" @keydown="onGridKeydown">
            <v-data-table :headers="headers" :items="items" item-key="id" :search="filtro" :custom-filter="filtroTabla"
                dense hide-default-footer :items-per-page="-1" class="excel-table">
                <template v-slot:top>
                </template>
                <template v-slot:item="{ item, index }">
                    <tr>
                        <td>{{ item.id }}</td>

                        <td>{{ item.grupo }}</td>

                        <td>
                            <v-list-item dense class="pa-0">
                                <v-list-item-content>
                                    <v-list-item-title class="text-body-2 font-weight-medium">
                                        {{ item.nombreComision }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="text-caption grey--text">
                                        {{ item.asignatura }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </td>

                        <!-- <td>{{ item.carrera }}</td>
                        <td>{{ item.sede }}</td> -->


                        <td data-col="docenteDni" :data-id="item.id" :data-row="index" :class="cellClass(index, 'docenteDni')"
                            @click="onCellClick(index, 'docenteDni', item.id)">
                            <v-chip v-if="item.docenteId == 1" color="red" outlined small>A designar</v-chip>
                            <span v-else color="blue" outlined small>{{item.nombreDocente}}</span>
                        </td>

                        <td data-col="fusion" :data-id="item.id" :data-row="index" :class="cellClass(index, 'fusion')"
                            @click="onCellClick(index, 'fusion', item.id)">
                            {{ item.fusion }}
                        </td>

                        <td data-col="semana" :data-id="item.id" :data-row="index" :class="cellClass(index, 'semana')"
                            @click="onCellClick(index, 'semana', item.id)">
                            {{ item.strSemana }}
                        </td>

                        <td data-col="dia" :data-id="item.id" :data-row="index" :class="cellClass(index, 'dia')"
                            @click="onCellClick(index, 'dia', item.id)">
                            {{ item.dia }}
                        </td>

                        <td data-col="horario" :data-id="item.id" :data-row="index" :class="cellClass(index, 'horario')"
                            @click="onCellClick(index, 'horario', item.id)">
                            {{ item.horario }}
                        </td>

                        <td data-col="cantidadEncuentros" :data-id="item.id" :data-row="index"
                            :class="cellClass(index, 'cantidadEncuentros')"
                            @click="onCellClick(index, 'cantidadEncuentros', item.id)">
                            {{ item.cantidadEncuentros }}
                        </td>
                    </tr>
                </template>
            </v-data-table>

            <EditorCell v-if="editing" :value="getEditingValue()" :type="editorType" :options="editorOptions"
                :rect="editorRect" @commit="commitEdit" @cancel="cancelEdit" @error="onHorarioError" />
        </div>
    </v-container>
</template>

<script>
import EditorCell from "../../components/tabla/EditorCell.vue";
import ComiPlaniService from "../../services/ComisionPlanificacion.service";


export default {
    components: { EditorCell },

    data() {
        return {
            headers: [
                { text: "Id", value: "id" },
                { text: "Grupo", value: "grupo" },
                { text: "Comisión", value: "nombreComision" },
                /*
                { text: "Carrera", value: "carrera" },
                { text: "Sede", value: "sede" }, 
                 */
                { text: "Docente", value: "docenteId" },
                { text: "Fusion", value: "fusion" },
                { text: "Semana", value: "semana" },
                { text: "Dia", value: "dia" },
                { text: "Hora hh:mm", value: "horario" },
                { text: "Encuentros", value: "cantidadEncuentros" },
            ],
            semestre: null,
            semestres: this.$store.semestres,
            filtro: '',
            items: [],
            itemsById: new Map(),
            snapshot: null,

            weekOptions: [
                { id: 1, nombre: "Verde" },
                { id: 2, nombre: "Turquesa" },
            ],
            diasSemana: [
                { nombre: "Lunes", id: "Lunes" },
                { nombre: "Martes", id: "Martes" },
                { nombre: "Miércoles", id: "Miércoles" },
                { nombre: "Jueves", id: "Jueves" },
                { nombre: "Viernes", id: "Viernes" },
                { nombre: "Sábado", id: "Sábado" },
            ],

            active: { row: 0, col: "docenteDni" },

            editing: null,
            editorRect: null,
            editorType: null,
            editorOptions: [],

            _scrollRaf: null,
            _onGridScroll: null,
        };
    },

    async mounted() {

        this._onGridScroll = () => this.cancelEdit();
        this.$refs.grid.addEventListener("scroll", this._onGridScroll);
    },

    beforeDestroy() {
        if (this._scrollRaf) cancelAnimationFrame(this._scrollRaf);

        if (this.$refs.grid && this._onGridScroll) {
            this.$refs.grid.removeEventListener("scroll", this._onGridScroll);
        }
    },

    methods: {
        selectSemestre() {
            this.ObtenerComiDistancia();
        },
        filtroTabla(value, search, item) {
            if (!search) return true;
            const text = search.toString().toLowerCase();
            // Recorre TODAS las columnas del item
            return Object.values(item).some(val => {
                if (val === null || val === undefined) return false;

                return val
                    .toString()
                    .toLowerCase()
                    .includes(text);
            });
        },
        async ObtenerComiDistancia() {
            if (!this.semestre) return;
            try {
                const result = await ComiPlaniService.ObtenerComiPlaniConfig(this.semestre.Id);
                this.items = result.data || [];
                this.itemsById = new Map(
                    this.items.map(i => [Number(i.id), i])
                );
                this.focusGrid();
            } catch (err) {
            }
        },

        focusGrid() {
            //this.$nextTick(() => this.$refs.grid?.focus());
            this.$nextTick(() => {
                const el = this.$refs.grid;
                if (!el) return;

                const y = window.scrollY;
                el.focus();
                window.scrollTo(0, y);
            });
        },

        cellClass(row, col) {
            /*   return {
                 "active-cell": this.active.row === row && this.active.col === col,
             }; */

            const isActive = this.active.row === row && this.active.col === col;

            const isEditingThis =
                this.editing &&
                this.editing.row === row &&
                this.editing.col === col;

            return {
                "active-cell": isActive && !isEditingThis,
            };
        },
        getCellId() {
            const cell = this.getActiveCellEl();
            if (!cell) return null;

            const id = Number(cell.dataset.id);
            return Number.isFinite(id) ? id : null;
        },
        getActiveCellEl() {
            const { row, col } = this.active;
            return this.$el.querySelector(`td[data-row="${row}"][data-col="${col}"]`);
        },

        ensureActiveVisible() {
            if (this._scrollRaf) cancelAnimationFrame(this._scrollRaf);

            this._scrollRaf = requestAnimationFrame(() => {
                const grid = this.$refs.grid;
                const cell = this.getActiveCellEl();
                if (!grid || !cell) return;

                const appbarH = 64;

                const gridRect = grid.getBoundingClientRect();
                const cellRect = cell.getBoundingClientRect();

                const topLimit = gridRect.top + appbarH + 6;
                const bottomLimit = gridRect.bottom - 6;

                if (cellRect.top < topLimit) {
                    const delta = topLimit - cellRect.top;
                    grid.scrollTop -= delta;
                    return;
                }

                if (cellRect.bottom > bottomLimit) {
                    const delta = cellRect.bottom - bottomLimit;
                    grid.scrollTop += delta;
                }
            });
        },

        getEditorType(col) {
            if (col === "docenteDni") return "ac-docente";
            if (col === "semana") return "select-semana";
            if (col === "dia") return "select-dia";
            if (col === "horario") return "time";
            if (col === "cantidadEncuentros") return "number";
            if (col === "fusion") return "text";
            return null;
        },

        getEditorOptions(col) {
            if (col === "semana") return this.weekOptions;
            if (col === "dia") return this.diasSemana;
            return [];
        },

        startEdit(row, col, id) {
            const cell = this.getActiveCellEl();
            if (!cell) return;
            id = Number(cell.dataset.id);
            if (!id) return;

            const rect = cell.getBoundingClientRect();
            const gridRect = this.$refs.grid.getBoundingClientRect();

            this.editorRect = {
                top: rect.top - gridRect.top + this.$refs.grid.scrollTop,
                left: rect.left - gridRect.left,
                width: rect.width,
                height: rect.height,
            };

            this.editorType = this.getEditorType(col);
            this.editorOptions = this.getEditorOptions(col);

            this.editing = { row, col, id };
        },
        getEditingValue() {
            if (!this.editing) return null;
            const item = this.itemsById.get(Number(this.editing.id));
            if (!item) return null;
            return item[this.editing.col];
        },

        commitEdit({ value, configEnter }) {

            const { id, col } = this.editing;
            console.log({ id, col, value });

            const item = this.itemsById.get(Number(id));
            if (!item) return;

            this.snapshot = { ...item };

            switch (col) {
                case "semana":
                    item[col] = value.id;
                    item.strSemana = value.nombre;
                    break;

                case "dia":
                    item[col] = value.id;
                    item.strdia = value.nombre;
                    break;
                case "docenteDni":
                    item.docenteId = value.id;
                    item.nombreDocente = value.nombre;
                    break;

                default:
                    item[col] = value;
                    break;
            }

            this.ActualizarComision(item, configEnter);
        },

        commitDelete(id, col) {
            const item = this.itemsById.get(id);
            if (!item) return;
            this.snapshot = { ...item };

            switch (col) {
                case "semana":
                    item[col] = null;
                    item.strSemana = "";
                    break;

                default:
                    item[col] = null;
                    break;
            }

            this.ActualizarComision(item, false);
        },

        ActualizarComision(item, configEnter) {
            ComiPlaniService.ActualizarComiPlani(item).then((result) => {
                //this.ObtenerComiDistancia();
                this.applyServerUpdates(result.data);
            }).catch(err => {
                Object.assign(item, this.snapshot);
                const msg = err?.response?.data || "Error";
                this.$toast.error(msg);
            })
                .finally(() => {
                });

            if (configEnter) {
                this.active.row = Math.min(this.active.row + 1, this.items.length - 1);
            }

            this.editing = null;
            this.focusGrid();
            this.ensureActiveVisible();
        },
        applyServerUpdates(updated) {
            if (!Array.isArray(updated) || updated.length === 0) return;

            for (const patch of updated) {
                const id = Number(patch.id);
                if (!id) continue;

                const item = this.itemsById.get(id);

                // si existe, merge in-place (reactivo)
                if (item) {
                    Object.assign(item, patch);
                    continue;
                }

                // si no existe, lo agrego
                const newItem = { ...patch };
                this.items.push(newItem);
                this.itemsById.set(id, newItem);
            }
        },

        cancelEdit() {
            this.editing = null;
            this.focusGrid();
        },

        moveCol(dx) {
            const cols = ["docenteDni", "fusion", "semana", "dia", "horario", "cantidadEncuentros"];
            const idx = cols.indexOf(this.active.col);
            const next = Math.min(Math.max(idx + dx, 0), cols.length - 1);
            this.active.col = cols[next];
        },

        onHorarioError(msg) {
            console.error(msg);
        },

        onGridKeydown(e) {
            if (this.editing) return;

            if (e.key === "ArrowUp") {
                e.preventDefault();
                this.active.row = Math.max(this.active.row - 1, 0);
                this.ensureActiveVisible();
                return;
            }

            if (e.key === "ArrowDown") {
                e.preventDefault();
                this.active.row = Math.min(this.active.row + 1, this.items.length - 1);
                this.ensureActiveVisible();
                return;
            }

            if (e.key === "ArrowLeft") {
                e.preventDefault();
                this.moveCol(-1);
                this.ensureActiveVisible();
                return;
            }

            if (e.key === "ArrowRight") {
                e.preventDefault();
                this.moveCol(1);
                this.ensureActiveVisible();
                return;
            }

            if (e.key === "Delete" || e.key === "Backspace") {
                e.preventDefault();
                var id = this.getCellId()
                if (!id) return;
                this.commitDelete(id, this.active.col);
                return;
            }
            if (e.key === "Enter") {
                e.preventDefault();
                this.onCellClick(this.active.row, this.active.col, null);
                this.ensureActiveVisible();
            }
        },

        onCellClick(row, col, id) {
            this.active = { row, col };

            if (this.editing) {
                if (this.editing.row === row && this.editing.col === col) return;
                this.editing = null;
            }

            this.$nextTick(() => {
                this.startEdit(row, col, id);
            });

            this.ensureActiveVisible();
        }
    },
};
</script>

<style scoped>
.grid-wrapper {
    outline: none;
    position: relative;
    max-height: calc(100vh - 120px);
    overflow: auto;
}

.excel-table td {
    padding: 4px 6px;
    height: 38px;
    cursor: pointer;
    box-sizing: border-box;
}

.active-cell {
    box-shadow: inset 0 0 0 2px #1976d2;
}

/* Columna "Comisión" (2da columna) */
::v-deep .excel-table td:nth-child(3),
::v-deep .excel-table th:nth-child(3) {
    width: 400px;
    max-width: 400px;
}

/* Columna "Comisión" (2da columna) */
::v-deep .excel-table td:nth-child(2),
::v-deep .excel-table th:nth-child(2),
::v-deep .excel-table td:nth-child(6),
::v-deep .excel-table th:nth-child(6),
::v-deep .excel-table td:nth-child(7),
::v-deep .excel-table th:nth-child(7),
::v-deep .excel-table td:nth-child(8),
::v-deep .excel-table th:nth-child(8) {
    width: 110px;
    max-width: 110px;
}

::v-deep .excel-table td:nth-child(1),
::v-deep .excel-table td:nth-child(2),
::v-deep .excel-table td:nth-child(9),
::v-deep .excel-table td:nth-child(1),
::v-deep .excel-table td:nth-child(9),
::v-deep .excel-table th:nth-child(5),
::v-deep .excel-table th:nth-child(9) {
    width: 80px;
    max-width: 80px;
}

/* Evitar que el contenido ensanche la celda */
::v-deep .excel-table td:nth-child(2) .v-list-item__content {
    overflow: hidden;
}

/* Ellipsis para título y subtítulo */
::v-deep .excel-table td:nth-child(2) .v-list-item__title,
::v-deep .excel-table td:nth-child(2) .v-list-item__subtitle {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>


<!-- <template>
    <div class="grid-wrapper" tabindex="0" ref="grid" @keydown="onGridKeydown">
        <v-data-table :headers="headers" :items="items" item-key="id" dense hide-default-footer :items-per-page="-1"
            class=" -table">
            <template v-slot:item="{ item, index }">
                <tr>

                    <td>
                        {{ item.id }}
                    </td>
                    <td>
                        <v-list-item dense class="pa-0">
                            <v-list-item-content>
                                <v-list-item-title class="text-body-2 font-weight-medium">
                                    {{ item.nombreComision }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-caption grey--text">
                                    {{ item.asignatura }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </td>
                    <td>
                        {{ item.carrera }}
                    </td>
                    <td>
                        {{ item.sede }}
                    </td>
                    <td>
                        {{ item.grupo }}
                    </td>
                    <td data-col="fusion" :data-id="item.id" :data-row="index" :class="cellClass(index, 'fusion')"
                        @click="onCellClick(index, 'fusion', item.id)">
                        {{ item.fusion }}
                    </td>
                    <td data-col="semana" :data-id="item.id" :data-row="index" :class="cellClass(index, 'semana')"
                        @click="onCellClick(index, 'semana', item.id)">
                        {{ item.strSemana }}
                    </td>

                    <td data-col="dia" :data-id="item.id" :data-row="index" :class="cellClass(index, 'dia')"
                        @click="onCellClick(index, 'dia', item.id)">
                        {{ item.dia }}
                    </td>

                    <td data-col="horario" :data-id="item.id" :data-row="index" :class="cellClass(index, 'horario')"
                        @click="onCellClick(index, 'horario', item.id)">
                        {{ item.horario }}
                    </td>

                    <td data-col="cantidadEncuentros" :data-id="item.id" :data-row="index"
                        :class="cellClass(index, 'cantidadEncuentros')"
                        @click="onCellClick(index, 'cantidadEncuentros', item.id)">
                        {{ item.cantidadEncuentros }}
                    </td>
                </tr>
            </template>
        </v-data-table>

        <EditorCell v-if="editing" :value="getEditingValue()" :type="editorType" :options="editorOptions"
            :rect="editorRect" @commit="commitEdit" @cancel="cancelEdit" @error="onHorarioError" />
    </div>
</template>

<script>
import EditorCell from "../../components/tabla/EditorCell.vue";
import ComiPlaniService from "../../services/ComisionPlanificacion.service";

export default {
    components: { EditorCell },

    data() {
        return {
            headers: [
                { text: "Id", value: "Id" },
                { text: "Comisión", value: "nombreComision" },
                { text: "Carrera", value: "carrera" },
                { text: "Sede", value: "sede" },
                { text: "Grupo", value: "grupo" },
                { text: "Fusion", value: "fusion" },
                { text: "Semana", value: "semana" },
                { text: "Dia", value: "dia" },
                { text: "Hora", value: "horario" },
                { text: "Encuentros", value: "cantidadEncuentros" },
            ],
            _scrollRaf: null,
            items: [],
            snapshot: null,
            itemsById: null,
            weekOptions: [{ id: 1, nombre: "Verde" }, { id: 2, nombre: "Turquesa" }],
            diasSemana: [
                { nombre: "Lunes", id: "Lunes" },
                { nombre: "Martes", id: "Martes" },
                { nombre: "Miércoles", id: "Miércoles" },
                { nombre: "Jueves", id: "Jueves" },
                { nombre: "Viernes", id: "Viernes" },
                { nombre: "Sábado", id: "Sábado" }
            ],
            active: { row: 0, col: "fusion" },
            editing: null,
            editorRect: null,
            editorType: null,
            editorOptions: [],
        };
    },

    async mounted() {
        await this.ObtenerComiDistancia();
        this.focusGrid();
        this.$refs.grid.addEventListener("scroll", this.cancelEdit);
    },

    methods: {
        getActiveCellEl() {
            const { row, col } = this.active;
            return this.$el.querySelector(`td[data-row="${row}"][data-col="${col}"]`);
        },
        ensureActiveVisible() {
            if (this._scrollRaf) cancelAnimationFrame(this._scrollRaf);

            this._scrollRaf = requestAnimationFrame(() => {
                const grid = this.$refs.grid;
                const cell = this.getActiveCellEl();
                if (!grid || !cell) return;

                const appbarH = 64;

                const gridRect = grid.getBoundingClientRect();
                const cellRect = cell.getBoundingClientRect();

                // límites visibles dentro del grid, descontando appbar
                const topLimit = gridRect.top + appbarH + 6;
                const bottomLimit = gridRect.bottom - 6;

                // si está arriba (tapada por appbar)
                if (cellRect.top < topLimit) {
                    const delta = topLimit - cellRect.top;
                    grid.scrollTop -= delta;
                    return;
                }

                // si está abajo
                if (cellRect.bottom > bottomLimit) {
                    const delta = cellRect.bottom - bottomLimit;
                    grid.scrollTop += delta;
                }
            });
        },
        ObtenerComiDistancia() {
            ComiPlaniService.ObtenerComiPlaniConfig(247).then((result) => {
                this.items = result.data;
                this.itemsById = new Map(this.items.map(i => [i.id, i]))
            }).catch((err) => {

            });
        },
        ActualizarComision(item, configEnter) {
            ComiPlaniService.ActualizarComiPlani(item).then((result) => {
            }).catch((err) => {
                // rollback real
                Object.assign(item, this.snapshot);
                this.$toast.error(err.response.data);
            }).finally(() => {
            });
            if (configEnter) {
                this.active.row = Math.min(this.active.row + 1, this.items.length - 1);
            }
            this.editing = null;
            this.focusGrid();
            this.ensureActiveVisible();
        },
        focusGrid() {
            this.$nextTick(() => this.$refs.grid?.focus());
        },
        cellClass(row, col) {
            return {
                "active-cell": this.active.row === row && this.active.col === col,
            };
        },
        startEdit(row, col, id) {
            const cell = this.$el.querySelector(
                `td[data-row="${row}"][data-col="${col}"]`
            );
            if (!cell) return;
            id = Number(cell.dataset.id);
            const rect = cell.getBoundingClientRect();
            const gridRect = this.$refs.grid.getBoundingClientRect();

            this.editorRect = {
                top: rect.top - gridRect.top + this.$refs.grid.scrollTop,
                left: rect.left - gridRect.left,
                width: rect.width,
                height: rect.height,
            };

            this.editorType = this.getEditorType(col);
            this.editorOptions = this.getEditorOptions(col);

            this.editing = { row, col, id };
        },
        getEditingValue() {
            if (!this.editing) return null;
            const item = this.items.find(i => i.id === this.editing.id);
            return item ? item[this.editing.col] : null;
        },
        getEditorType(col) {
            if (col === "semana") return "select-semana";
            if (col === "dia") return "select-dia";
            if (col === "horario") return "time";
            if (col === "cantidadEncuentros") return "number";
            if (col === "fusion") return "text";
            return null;
        },
        getEditorOptions(col) {
            if (col === "semana") return this.weekOptions;
            if (col === "dia") return this.diasSemana;
            return [];
        },
        commitEdit({ value, configEnter }) {
            const { id, col } = this.editing;
            let item = this.itemsById.get(id);
            console.log(typeof id, this.itemsById.get(id));
            this.snapshot = { ...item };
            if (!item) return;

            switch (col) {
                case "semana":
                    item[col] = value.id;
                    item.strSemana = value.nombre;
                    break;

                case "dia":
                    item[col] = value.id;
                    item.strdia = value.nombre;
                    break;

                default:
                    item[col] = value;
                    break;
            }
            this.ActualizarComision(item, configEnter);
        },
        commitDelete(item, col) {
            this.snapshot = { ...item };
            switch (col) {
                case "semana":
                    item[col] = null;
                    item.strSemana = "";
                    break;

                case "dia":
                    item[col] = null;
                    break;
                default:
                    item[col] = null;
                    break;
            }
            this.ActualizarComision(item, false);
        },
        cancelEdit() {
            this.editing = null;
            this.focusGrid();
        },
        onGridKeydown(e) {
            if (this.editing) return;

            if (e.key === "ArrowUp") {
                e.preventDefault();
                this.active.row = Math.max(this.active.row - 1, 0);
                this.ensureActiveVisible();
            }

            if (e.key === "ArrowDown") {
                e.preventDefault();
                this.active.row = Math.min(this.active.row + 1, this.items.length - 1);
                this.ensureActiveVisible();
            }

            if (e.key === "ArrowLeft") {
                e.preventDefault();
                this.moveCol(-1);
                this.ensureActiveVisible();
            }

            if (e.key === "ArrowRight") {
                e.preventDefault();
                this.moveCol(1);
                this.ensureActiveVisible();
            }

            if (e.key === "Delete" || e.key === "Backspace") {
                e.preventDefault();
                const item = this.items[this.active.row];
                if (!item) return;
                const col = this.active.col;
                this.commitDelete(item, col);
            }

            if (e.key === "Enter") {
                e.preventDefault();
                const item = this.items[this.active.row];
                if (!item) return;
                console.log("E_active!!", { ...this.active });
                this.onCellClick(this.active.row, this.active.col, item.id);
                this.ensureActiveVisible();
            }
        },

        moveCol(dx) {
            const cols = ["fusion", "semana", "dia", "horario", "cantidadEncuentros"];
            const idx = cols.indexOf(this.active.col);
            const next = Math.min(Math.max(idx + dx, 0), cols.length - 1);
            this.active.col = cols[next];
        },
        onHorarioError(msg) {
            console.error(msg);
        },
        onCellClick(row, col, id) {
            // 1. mover foco visual SIEMPRE
            this.active = { row, col, id };
            console.log("CC_active!!", { ...this.active });

            // 2. si ya estoy editando otra celda → cerrar
            if (this.editing) {
                // si es la misma celda, no hagas nada
                if (
                    this.editing.row === row &&
                    this.editing.col === col
                ) {
                    return;
                }

                // cerrar editor actual
                this.editing = null;
            }

            // 3. abrir editor nuevo (nextTick para evitar colisión)
            this.$nextTick(() => {
                this.startEdit(row, col, id);
            });
            this.ensureActiveVisible();
        },
    },
};
</script>

<style scoped>
.grid-wrapper {
    outline: none;
    position: relative;
    max-height: calc(100vh - 64px);
    overflow: auto;
}

.excel-table td {
    padding: 4px 6px;
    height: 36px;
    cursor: pointer;
}

.active-cell {
    box-shadow: inset 0 0 0 2px #1976d2;
}
</style>
 -->